module.exports = __webpack_public_path__ + "img/空白（切口图）.8bb333df.jpg";